import { ref } from 'vue';

import { getCompanyCode } from '@/views/Infrastructure/services';
import { TReachedResponse } from '@/api/types';
import { TCompanyCodeInfo } from '@/types';
import { TSelectOption } from '@/ui/types';
import { showErrorNotification } from '@/utils';

export const useFetchData = () => {
  const companyCodes = ref<TSelectOption[]>([]);

  const fetchCompanyCode = (email: string) => {
    getCompanyCode(email)
      .then((response: TReachedResponse<TCompanyCodeInfo[]>) => {
        if (!response) return;
        companyCodes.value = response.data.map((item: TCompanyCodeInfo) => ({
          value: item.authCode,
          label: item.authCode,
        }) as TSelectOption);
      })
      .catch(showErrorNotification);
  };

  return {
    companyCodes,
    fetchCompanyCode,
  };
};
